import {Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale, TimeSeriesScale} from 'chart.js';
import {Line} from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-moment';

ChartJS.register(CategoryScale, TimeScale, TimeSeriesScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, zoomPlugin);

const Graph = (props) => {
    const plugins = {
        title: {
            display: true,
            text: props.graphName,
        },
        zoom: {
            pan: {
                enabled: true,
                mode: 'xy',
            },
            zoom: {
                wheel: {
                    enabled: true,
                },
                pinch: {
                    enabled: true,
                },
                mode: 'x',
            },
        },
    };

    const dateFormat = 'YYYY/MM/DD HH:mm:ss';

    const options = {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: true,
        plugins: plugins,
        scales: {
            x: {
                type: 'time',
                unit: 'hour',
                time: {
                    tooltipFormat:dateFormat,
                    displayFormats: {
                        'millisecond': dateFormat,
                        'second': dateFormat,
                        'minute': dateFormat,
                        'hour': dateFormat,
                        'day': dateFormat,
                        'week': dateFormat,
                        'month': dateFormat,
                        'quarter': dateFormat,
                        'year': dateFormat,
                    },
                round: true
                }
            }
        },
        elements: {
            point: {
                radius: 0,
            },
        },
    };
    
    if (props.graphData !== {}) {
        const labels = [];
        const tempData = [];

        Object.keys(props.graphData).forEach((date) => {
            const dateLabel = new Date(date);
            labels.push(dateLabel);


            const values = props.graphData[date];

            Object.keys(values).forEach((index) => {
                const dataLabel = props.header[Number(index) + 1];

                if(tempData[dataLabel] !== undefined) {
                    tempData[dataLabel].push(values[index]);
                } else {
                    tempData[dataLabel] = [];
                    tempData[dataLabel].push(values[index]);
                }
            })
        });

        const datasets = [];

        Object.keys(tempData).forEach((key) => {
            const r = Math.floor(Math.random() * 200);
            const g = Math.floor(Math.random() * 200);
            const b = Math.floor(Math.random() * 200);

            const dateset = {
                label: key,
                data: tempData[key],
                borderColor: `rgb(${r}, ${g}, ${b})`,
                backgroundColor: `rgba(${r}, ${g}, ${b}, 0.5)`,
            }

            datasets.push(dateset);
        });

        const data = {
            labels,
            datasets: datasets
        };

        if (labels.length > 0) {
            return (
                <div className='graph'>
                    <Line options={options} data={data} />
                </div>
            );
        }
    }

    return (<></>)
};

export default Graph;
